var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('HeaderBanner')],1),_c('FeaturedApartments'),_c('b-container',[_c('CheckIn'),_c('BecomeHost')],1),_c('b-container',[_c('Blog')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }